import React,{ Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Row, Col, Table, Button, Card, CardBody, CardHeader} from "reactstrap";
import { getImages } from "../../../actions/actionImage";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";
import ReactJson from 'react-json-view';
import { bytesToSize } from "../../../utils/helpers"
import iconNo from "../../../../assets/images/icon_no.svg";
import iconYes from "../../../../assets/images/icon_yes.svg";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Images",path:"/images",isActive: false},
    {name: "ViewImages",path:"/viewimage",isActive: true},
];

class ViewImage extends Component{
    constructor(props){
        super(props);
        this.state = {
            currentImage: null,
            userId: null
        };
    }

    componentDidMount(){
        this.props.getImages();
    }

    UNSAFE_componentWillReceiveProps(nextProps){
        if(nextProps.images.length > 0){
            let currentImage = nextProps.images.find(image => image.image_id === this.props.match.params.id);
            this.setState({currentImage: currentImage});
        }
    }


    render(){
        const {currentImage} = this.state;
        return (
            <div className="profile-page">
                <BreadCrumbCompo routes={routes}/>    
                <Row>
                    <Col sm={{ size: 8, order: 3, offset: 2 }}>
                        <Card >
                            <CardHeader>
                               <strong>View Image</strong>
                                {currentImage ? <Link className="pull-right" to={{ pathname: `/updateimage/${currentImage.image_id}`}}> 
                                    <Button size="sm" 
                                    className = "reset-btn" 
                                    color="primary"> Edit Image </Button> </Link> : " " }
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col xs="12">                    
                                    <div className="profile-table">
                                            {currentImage?
                                                <Table >
                                                    <tbody>
                                                        <tr><td><h4>Image Id</h4></td><td>{currentImage.image_id ? currentImage.image_id : "-"}</td></tr>
                                                        <tr><td><h4>Docker Image </h4></td><td>{currentImage.name ? currentImage.name : "-"}</td></tr>
                                                        <tr><td><h4>Description</h4></td><td>{currentImage.description ? currentImage.description : "-"}</td></tr>
                                                        <tr><td><h4>Friendly Name</h4></td><td>{currentImage.friendly_name ? currentImage.friendly_name : "-"}</td></tr>
                                                        <tr><td><h4>Thumbnail URL</h4></td><td>{currentImage.image_src ? currentImage.image_src : "-"}</td></tr>
                                                        <tr><td><h4>Cores</h4></td><td>{currentImage.cores ? currentImage.cores : "-"}</td></tr>
                                                        <tr><td><h4>Friendly Name</h4></td><td>{currentImage.friendly_name ? currentImage.friendly_name : "-"}</td></tr>
                                                        <tr><td><h4>Memory</h4></td><td>{currentImage.memory ? bytesToSize(currentImage.memory) : "-"}</td></tr>
                                                        <tr><td><h4>Requires GPU</h4></td><td> <img src={currentImage.require_gpu ? iconYes : iconNo} alt="yesNoIcon"/></td></tr>
						                                <tr><td><h4>GPU Count</h4></td><td>{(currentImage.gpu_count) ? currentImage.gpu_count : ( currentImage.require_gpu ? "All" : "-")}</td></tr>
						                                <tr><td><h4>Enabled</h4></td><td> <img src={currentImage.enabled ? iconYes : iconNo} alt="yesNoIcon"/></td></tr>
                                                        <tr><td><h4>Docker Registry</h4></td><td>{currentImage.docker_registry ? currentImage.docker_registry : "-"}</td></tr>
                                                        <tr><td><h4>Docker Registry Username</h4></td><td>{currentImage.docker_user ? currentImage.docker_user : "-"}</td></tr>
                                                        <tr><td><h4>Docker Registry Password</h4></td><td>{currentImage.docker_token ? currentImage.docker_token : "-"}</td></tr>
                                                        <tr><td><h4>Hash</h4></td><td>{currentImage.hash ? currentImage.hash : "-"}</td></tr>
                                                        <tr><td><h4>Persistent Profile Path</h4></td><td>{currentImage.persistent_profile_path ? currentImage.persistent_profile_path : "-"}</td></tr>
                                                        <tr><td><h4>Volume Mappings</h4></td><td className="word-wrap">
                                                            <ReactJson src={currentImage.volume_mappings}
                                                                name={false}
                                                                collapsed={false}
                                                                sortKeys={true}
                                                                collapseStringsAfterLength={40}
                                                                enableClipboard={false}
                                                                displayDataTypes={false}
                                                            />
                                                        </td></tr>
                                                        <tr><td><h4>Run Config</h4></td><td className="word-wrap">
                                                            <ReactJson src={currentImage.run_config}
                                                                name={false}
                                                                collapsed={false}
                                                                sortKeys={true}
                                                                collapseStringsAfterLength={40}
                                                                enableClipboard={false}
                                                                displayDataTypes={false}
                                                            />
                                                        </td></tr>
                                                        <tr><td><h4>Exec Config</h4></td><td className="word-wrap">
                                                            <ReactJson src={currentImage.exec_config}
                                                                name={false}
                                                                collapsed={false}
                                                                sortKeys={true}
                                                                collapseStringsAfterLength={40}
                                                                enableClipboard={false}
                                                                displayDataTypes={false}
                                                            />
                                                        </td></tr>
                                                        <tr><td><h4>Categories</h4></td><td className="word-wrap">
                                                            <ReactJson src={currentImage.categories ? currentImage.categories : []}
                                                                name={false}
                                                                collapsed={false}
                                                                sortKeys={true}
                                                                collapseStringsAfterLength={40}
                                                                enableClipboard={false}
                                                                displayDataTypes={false}
                                                            />
                                                        </td></tr>
                                                        <tr><td><h4>Session Time Limit (Seconds)</h4></td><td>{currentImage.session_time_limit ? currentImage.session_time_limit : "-"}</td></tr>
                                                        <tr><td><h4>Web Filter Policy</h4></td><td>{currentImage.filter_policy_name ? currentImage.filter_policy_name : "-"}</td></tr>
                                                        <tr><td><h4>Allow Network Selection</h4></td><td><img src={currentImage.allow_network_selection ? iconYes : iconNo} alt="yesNoIcon"/></td></tr>
                                                        <tr><td><h4>Restrict Image to Docker Network </h4></td><td><img src={currentImage.restrict_to_network ? iconYes : iconNo} alt="yesNoIcon"/></td></tr>
                                                        <tr><td><h4>Docker Networks</h4></td><td className="word-wrap">
                                                            <ReactJson src={currentImage.restrict_network_names ? currentImage.restrict_network_names : []}
                                                                name={false}
                                                                collapsed={false}
                                                                sortKeys={true}
                                                                collapseStringsAfterLength={40}
                                                                enableClipboard={false}
                                                                displayDataTypes={false}
                                                            />
                                                        </td></tr>
                                                        <tr><td><h4>Custom Network Name </h4></td><td>{currentImage.network_name ? currentImage.network_name : "NA"}</td></tr>
                                                        <tr><td><h4>Restrict Image to Kasm Agent</h4></td><td><img src={currentImage.restrict_to_server ? iconYes : iconNo} alt="yesNoIcon"/></td></tr>
                                                        <tr><td><h4>Kasm Agent</h4></td><td>{currentImage.server_id ? currentImage.server_id : "NA"}</td></tr>
                                                    </tbody>                             
                                                </Table>   : " "} 
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>   
                    </Col>
                </Row>
            </div>
        );}
}

ViewImage.propTypes = {
    getImages: Proptypes.func.isRequired,
    images: Proptypes.array,
    match: Proptypes.object
};

export default connect(state => 
    ({
        images: state.images.images || []
    }),
dispatch => 
    ({  
        getImages: () => dispatch(getImages())
    }))(ViewImage);



// WEBPACK FOOTER //
// ./src/views/Images/ViewImage/ViewImage.js